import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';

/**
 * @typedef {import('../../App.d.ts').DefaultHeadlineMapperInterface} DefaultHeadlineMapperInterface
 */
/**
 *
 * @param {DefaultHeadlineMapperInterface} props
 * @returns {Element}
 * @constructor
 */
export default ({ headline, subheadline }) => (
  <Container>
    <div
      data-testid="dual-headline"
      className="dodo-component-dual-headline"
    >
      <h1>{headline}</h1>
      <p>{subheadline}</p>
    </div>
  </Container>
);
